'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$68() {
}
export { $c_Lmealorama_jsonCodecs$package$$anon$68 as $c_Lmealorama_jsonCodecs$package$$anon$68 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$68.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_sr_AbstractPartialFunction();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$68;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$68() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$68 as $h_Lmealorama_jsonCodecs$package$$anon$68 };
$h_Lmealorama_jsonCodecs$package$$anon$68.prototype = $p;
$p.Q = (function(x) {
  return (false || false);
});
$p.N = (function(x, default$1) {
  return (false ? new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_util_Left(x.am) : default$1.d(x));
});
var $d_Lmealorama_jsonCodecs$package$$anon$68 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$68, "mealorama.jsonCodecs$package$$anon$68", ({
  Kn: 1,
  k: 1,
  f: 1,
  g: 1,
  a: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$68 as $d_Lmealorama_jsonCodecs$package$$anon$68 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$68.js.map
